import { useState, useCallback } from 'react';
import { usePlacesQuery } from 'services/places';
import { debounce } from '@cat-ecom/common/utils/commonUtils';
import { DEBOUNCE_TIME_MILLISECONDS } from 'constants/common';

const usePlaces = () => {
  const [searchValue, setSearchValue] = useState('');

  //With the introduction of the new fetchStatus for better offline support, the idle state became irrelevant
  //because fetchStatus: 'idle' captures the same state
  // isFetching: A derived boolean from the fetchStatus variable
  //https://tanstack.com/query/latest/docs/framework/react/guides/migrating-to-react-query-4
  // TODO - Input Validation - Ensure that all values passed to the service are allowed values:
  // searchValue should always be a string restricting generalRestrictedCharacters (@\constants\securityConstants.ts).
  const { data, isPending, isFetching } = usePlacesQuery({
    searchValue
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getPlaces = useCallback(
    debounce((inputValue: string) => {
      setSearchValue(inputValue);
    }, DEBOUNCE_TIME_MILLISECONDS),
    [setSearchValue]
  );

  const responseSuggestions =
    data?.resourceSets?.[0]?.resources?.[0]?.value?.map(
      (elem) => elem.address.formattedAddress
    );
  const suggestions = (searchValue && responseSuggestions) || [];

  return {
    getPlaces,
    isLoading: isPending,
    searchValue,
    suggestions,
    isIdle: isFetching
  };
};

export default usePlaces;
